import { render, staticRenderFns } from "./sj-editor.vue?vue&type=template&id=5d82cf70&scoped=true"
import script from "./sj-editor.vue?vue&type=script&lang=js"
export * from "./sj-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82cf70",
  null
  
)

export default component.exports